import { useState } from "react";
import { Box, Button, Checkbox, Divider, FormControlLabel, Popover, Stack } from "@mui/material";
import { ArrowDropDown, Store } from "@mui/icons-material";
import type { Company } from "@/api/company.service";

// Seletor das lojas da ruptura: todas marcadas por padrão, desmarcar tira a loja da tela.
// ponytail: por enquanto só a tela; ainda não filtra as buscas (as queries aceitam uma loja só).
export function SeletorLojas({
  lojas,
  desmarcadas,
  onChange,
}: {
  lojas: Company[];
  // Códigos (erp_code) das lojas tiradas; vazio = todas.
  desmarcadas: Set<string>;
  onChange: (desmarcadas: Set<string>) => void;
}) {
  const [ancora, setAncora] = useState<HTMLElement | null>(null);
  const marcadas = lojas.length - lojas.filter((l) => desmarcadas.has(l.erp_code)).length;
  const rotulo = marcadas === lojas.length ? "Lojas (todas)" : `Lojas (${marcadas} de ${lojas.length})`;

  const alternar = (codigo: string) => {
    const novo = new Set(desmarcadas);
    if (!novo.delete(codigo)) novo.add(codigo);
    onChange(novo);
  };

  return (
    <>
      <Button
        size="small"
        variant={desmarcadas.size > 0 ? "contained" : "outlined"}
        startIcon={<Store fontSize="small" />}
        endIcon={<ArrowDropDown />}
        onClick={(e) => setAncora(e.currentTarget)}
        disabled={lojas.length === 0}
        sx={{ flexShrink: 0, whiteSpace: "nowrap" }}
      >
        {rotulo}
      </Button>
      <Popover
        open={!!ancora}
        anchorEl={ancora}
        onClose={() => setAncora(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Box sx={{ p: 1.5, minWidth: 240, maxHeight: 380, overflowY: "auto" }}>
          <Stack direction="row" justifyContent="space-between" sx={{ mb: 0.5 }}>
            <Button size="small" onClick={() => onChange(new Set())}>
              Selecionar todas
            </Button>
            <Button size="small" onClick={() => onChange(new Set(lojas.map((l) => l.erp_code)))}>
              Limpar
            </Button>
          </Stack>
          <Divider sx={{ mb: 0.5 }} />
          <Stack>
            {lojas.map((l) => (
              <FormControlLabel
                key={l.erp_code}
                label={l.name}
                control={<Checkbox size="small" checked={!desmarcadas.has(l.erp_code)} onChange={() => alternar(l.erp_code)} />}
                slotProps={{ typography: { variant: "body2" } }}
              />
            ))}
          </Stack>
        </Box>
      </Popover>
    </>
  );
}
